// T8.3: Substitui o switcher de 3 idiomas pelo renderer de 16 locales.
// O renderer monta o switcher dinamicamente, gerencia fallback transparente
// (pt-BR para locales sem tradução completa) e persiste a escolha.

import { initLegalPageI18n } from '../utils/i18n/legalPageRenderer.js';

initLegalPageI18n({
    type: 'terms',
    containerSelector: '.legal-container',
    switcherSelector: '.lang-switcher',
    titleSelector: '.legal-header h1',
    backLinkSelector: '.back-link',
});
